<template lang="pug">
#resident-list(v-cloak)
  .box.d-print-none
    .box-header
      .d-flex.flex-row
        .d-flex.flex-column.flex-fill
          .title
            span 利用者
          .messages
            span ご利用者の登録・削除、ご家族にお渡しする「ID通知書」を印刷できます。
          .messages(v-if="!isLoading")
            span(v-if="_registrationLimit") 登録済み利用者数：{{ registerdResidentCount }}人（登録可能利用者数：{{ _registrationLimit }}）
          .messages(v-if="!isLoading && _isRegistrationLimit")
            span.error-message ご契約プランの利用者情報登録数上限に達しています。
            br
            span.error-message 新規に追加する場合は設定画面からプラン変更もしくは利用者情報を削除してから行ってください。
        .buttons.d-flex.flex-row-reverse.justify-content-end.flex-wrap(v-if="_plan != -1 && !isLoading")
          template(v-if="_isRegistrationLimit")
            button#disable-add-btn.btn.add-btn.disable 利用者追加
            b-popover(target="disable-add-btn" triggers="hover" placement="bottom")
              template(v-slot:title) 利用者追加ボタン
              span 登録可能利用者数に達しているため、利用者追加ができません。
              br
              span ※ 登録可能利用者数の多い料金プランに変更すると追加できます。
            button#disable-multiple-add-btn.btn.multiple-add-btn.disable.mr-2(v-if="_userRole != 2") 利用者一括追加
            b-popover(target="disable-multiple-add-btn" triggers="hover" placement="bottom")
              template(v-slot:title) 利用者一括追加ボタン
              span 登録可能利用者数に達しているため、利用者追加ができません。
              br
              span ※ 登録可能利用者数の多い料金プランに変更すると追加できます。
          template(v-else)
            button.btn.add-btn(@click="gotoResidentRegister()") 利用者追加
            button.btn.multiple-add-btn.mr-2(v-if="_userRole != 2" @click="gotoMultipleResidentRegister()") 利用者一括追加

          button.btn.get-residents-btn.mr-2(v-if="_enableGetResidentsButton" @click="gotoGetResidentsForCooperationSystem") 連携システムから取得
          button.btn.group-list-btn.mr-2(v-if="1 <= getPlanType" @click="gotoResidentGroupList()") 利用者グループ設定
          template(v-else)
            button#disable-group-list-btn.btn.group-list-btn.disable 利用者グループ設定
            b-popover(target="disable-group-list-btn" triggers="hover" placement="bottom")
              template(v-slot:title) 利用者グループ設定ボタン
              span 無所属以外の任意の利用者グループを作成できます。利用者グループごとに異なる面会日程を作成できます。
              br
              span ※ ライトプラン以上で使用可能
    .box-body(style="padding-top:0;")
      .d-flex.justify-content-end
        .refresh-icon(@click.stop="refresh" title="再読み込みします")
      .mb-2
      ResidentTable(
        v-model="items"
        :fields="fields"
        :totalRows.sync="rows"
        :currentPage.sync="currentPage"
        :perPage="perPage"
        :isLoading="isLoading"
        :filter="filter"
        @onShowFamilies="showFamilies"
        @onShowServiceRegisterGuide="showServiceRegisterGuide"
        @onDetail="gotoResidentDetail"
        @onGotoResidentEdit="gotoResidentEdit"
        @onShowConfirmDeleteModal="showConfirmDeleteModal"
      )
      .table-options.d-flex.flex-row.justify-content-end.align-items-center.flex-wrap
        //- CSVダウンロード
        button.btn.download-btn.mr-2(:class="{ 'disable': isLoading }" :disabled="isLoading" @click="onCsvDownload") ダウンロード
        //- 検索
        .search-filter.d-flex.mr-1.align-items-center.mr-2
          b-input-group.search-filter-input-group.mr-1(size="md")
            b-input-group-prepend
              b-input-group-text.search-filter-icon
                .search-icon
            b-form-input.search-filter-input(v-model="filter.searchWord" type="search" placeholder="検索ワードを入力してください")
          HelpIcon.d-flex.justify-content-end.align-items-center(popoverId="search-filter-help" title="検索項目について")
            template(v-slot:text)
              div 検索項目は以下になります。
              div ・利用者名
              div ・利用者名（ふりがな）
              div ・部屋名
        //- フィルタリング
        span.table-option-text 利用者グループ:
        .filter
          b-form-select(
            id="filter-input"
            v-model="filter.id"
            :options="filterOptions"
            size="md"
          )
        //- ページあたりの行数
        span.table-option-text 1ページの行数:
        .per-page
          b-form-select(
            id="per-page-select"
            v-model="perPage"
            :options="pageOptions"
            size="md"
            @change="selectPerPage"
          )
        //- ページネーション
        b-pagination.m-0(
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          :disabled="isLoading"
          @change="selectPage"
          hide-goto-end-buttons
        )

  //- delete resident modals
  ResidentCheckDeleteModal(
    v-model="showDeleteModal"
    :title="deleteMessage" :sendMessage.sync="sendDeleteMessage" :deleteMessageTitle.sync="deleteModalMessageTitle" :deleteMessageText.sync="deleteModalMessageText"
    :showSendDeleteMessage="showSendDeleteMessage"
    @ok="doDelete")
    template(#message)
      .message 削除前に以下をご確認ください。
      ul.confirm-list
        li 削除したご利用者ご家族のHitomeQコネクトのユーザー登録情報も削除します。
        li 削除したご家族はHitomeQコネクトの機能を使用できなくなります。
        li 削除後にご家族が再使用する場合は、再度ご家族にユーザー登録していただく必要があります。
  OkModal(v-model="showDeleteSuccessModal" title="削除に成功しました。")
  //- family detail modal
  FamilyDetailModal(v-model="showFamilyDetailModal" :families="families" 
    @onEdit="gotoFamilyEdit"
    @onLineDelete="showConfirmFamilyDeleteModal"
    @onMailDelete="showConfirmMailFamilyDeleteModal"
    @onSendMessage="showTestMailModal")
  //- delete family modals
  ResidentCheckDeleteModal(
    v-model="showFamilyDeleteModal"
    :title="deleteMessage" :sendMessage.sync="sendDeleteMessage" :deleteMessageTitle.sync="deleteModalMessageTitle" :deleteMessageText.sync="deleteModalMessageText"
    @ok="deleteFamily")
    template(#message)
      .message 削除前に以下をご確認ください。
      ul.confirm-list
        li 削除したご家族はHitomeQコネクトの機能を使用できなくなります。
        li 削除後にご家族が再使用する場合は、再度ご家族にユーザー登録していただく必要があります。
  CheckDeleteModal(v-model="showDeleteMailFamilyModal" :title="deleteMessage" @ok="deleteMailFamily")
    template(#message)
      .message 削除前に以下をご確認ください。
      ul.confirm-list
        li 削除したご家族はHitomeQコネクトからのメールを受信できなくなります。
        li 削除後に再使用する場合は、再度ユーザー登録していただく必要があります。
  OkModal(v-model="showFamilyDeleteSuccessModal" title="削除に成功しました。")
  //- test mail modals
  TestMailModal(v-model="testMailModalShow" :target.sync="testMailFamilyTargetName" :subject.sync="testMailSubject" :text.sync="testMailText"
    :targetType="1" :showValidationAlert.sync="showValidationAlert" @sendMail="confirmSendMail")
  TestMailConfirmModal(v-model="testMailConfirmModalShow" :target="testMailFamilyTargetName" :subject="testMailSubject" :text="testMailText" @sendMail="sendMail")
  OkModal(v-model="showSendMailSuccessModal" title="メールを送信しました。")
  //- show password modal
  RegistrationGuidePdfModal(ref="pdf")
  //- loading modal
  PageLoading(:isBusy="isBusy" :message="loadingMessage")
</template>

<script lang="ts">
import { Component, Inject, Watch, Vue } from "vue-property-decorator";
import { userStore, itemListFilterStore, needRefreshesStore } from "@/store/store";
import { FamilyListState, SendMessagesState } from "@/store/NeedRefreshes";
import { errorHandle } from "@/errorHandler";

import Setting from "../../../../public/setting.json";
import { PcUrl } from "@/commons/constants/PcUrl";
import PlansService, { Plan, PlanDetail, PlansGetModel, PlanType } from "@/commons/services/Plans";
import ResidentsService, { ResidentDeleteModel, ResidentGetModel } from "@/commons/services/Residents";
import FamiliesService, { FamilyDeleteModel, FamilyGetModel } from "@/commons/services/Families";
import ResidentGroupsService, { ResidentGroupsGetModel } from "@/commons/services/ResidentGroups";
import MailFamiliesService from "@/commons/services/MailFamilies";
import SendMailMessagesService, { SendMailMessagesPostModel } from "@/commons/services/SendMailMessages";
import SystemError from "@/commons/models/SystemError";

import OkCancelModal from "@/pc/basics/OkCancelModal.vue";
import OkModal from "@/pc/basics/OkModal.vue";
import PageLoading from "@/pc/basics/PageLoading.vue";
import HelpIcon from "@/pc/basics/HelpIcon.vue";
import FamilyDetailModal from "@/pc/components/modals/FamilyDetailModal.vue";
import RegistrationGuidePdfModal from "@/pc/components/modals/RegistrationGuidePdfModal.vue";
import ResidentTable, { ResidentTableField, ResidentTableItem, FilterSetting } from "@/pc/containers/residents/ResidentTable.vue";
import { Role } from "@/commons/services/Authorization";
import CheckDeleteModal from "@/pc/components/modals/CheckDeleteModal.vue";
import ResidentCheckDeleteModal from "@/pc/components/residents/ResidentCheckDeleteModal.vue";
import TestMailModal from "@/pc/components/modals/TestMailModal.vue";
import TestMailConfirmModal from "@/pc/components/modals/TestMailConfirmModal.vue";
import { FacilityGetModel } from "@/commons/services/Facilities";

/**
 * 利用者一覧画面コンポーネント
 */
@Component({
  components: {
    PageLoading,
    OkCancelModal,
    OkModal,
    HelpIcon,
    FamilyDetailModal,
    RegistrationGuidePdfModal,
    ResidentTable,
    CheckDeleteModal,
    ResidentCheckDeleteModal,
    TestMailModal,
    TestMailConfirmModal
  },
  name: "ResidentList",
  $_veeValidate: { validator: "new" }
})
export default class ResidentList extends Vue {
  /** プランサービス */
  @Inject("PlansService") plansService!: PlansService;
  /** 利用者サービス */
  @Inject("ResidentsService") residentsService!: ResidentsService;
  /** 家族サービス */
  @Inject("FamiliesService") familiesService!: FamiliesService;
  /** 家族メールユーザーサービス */
  @Inject("MailFamiliesService") mailFamiliesService!: MailFamiliesService;
  /** メール送信サービス */
  @Inject("SendMailMessagesService") sendMailMessagesService!: SendMailMessagesService;
  /** 利用者グループサービス */
  @Inject("ResidentGroupsService") residentGroupsService!: ResidentGroupsService;

  /** ページ全体ローディング表示可否 */
  isBusy: boolean = false;
  /** ローディングメッセージ */
  loadingMessage: string = "";
  /** 家族削除モーダル表示可否 */
  showFamilyDeleteModal: boolean = false;
  /** 削除確認モーダル表示可否 */
  showDeleteModal: boolean = false;
  /** 削除完了モーダル表示可否 */
  showDeleteSuccessModal: boolean = false;
  /** 家族ユーザー詳細モーダル表示可否 */
  showFamilyDetailModal: boolean = false;

  /** バリデーションアラート表示可否 */
  showValidationAlert: boolean = false;

  /** 利用者列名 */
  fields: Array<ResidentTableField> = [];
  /** 利用者各行の情報 */
  items: Array<ResidentTableItem> = [];
  /** 読込み中か否か */
  isLoading: boolean = true;
  /** プラン */
  plans: Array<PlansGetModel> = [];
  /** グループIDとグループ名のMAP */
  groupNameMap: Map<number, string> = new Map();
  /** 削除対象の利用者ID */
  deleteTargetId: number = 0;
  /** 削除モーダルに表示するメッセージ */
  deleteMessage: string = "";

  /** 登録済み利用者数 */
  registerdResidentCount: number = 0;

  /** モーダル表示対象の家族 */
  families: any = {};
  /** モーダル表示対象のPDF Url */
  pdfUrl: string = "";

  /** フィルタリング条件 */
  filter: FilterSetting = { searchWord: "", id: "" };
  /** フィルター選択項目 */
  filterOptions: Array<{ value: string; text: string }> = [];
  /** ページングの現在ページ番号 */
  currentPage: number = 1;
  /** ページングの全体行数 */
  rows: number = 0;
  /** 1ページに表示する行数 */
  perPage: number = Number(Setting.resident.perPage);
  /** 1ページに表示する行数の選択項目 */
  pageOptions: number[] = Setting.resident.pageOptions;

  /** 削除対象の利用者ID */
  deleteTargetResidentId: number = 0;
  /** 削除対象の家族ID */
  deleteTargetFamilyId: number = 0;
  /** 家族削除モーダル表示可否 */
  showFamilyDeleteSuccessModal: boolean = false;
  /** メール家族の削除確認モーダル表示可否 */
  showDeleteMailFamilyModal: boolean = false;
  /** 削除メッセージを表示するか否か、家族がいない場合の利用者削除の場合は削除メッセージは送信不要なので表示制御している */
  showSendDeleteMessage: boolean = false;
  /** 削除メッセージの送信可否 */
  sendDeleteMessage: boolean | null = null;
  /** 削除メッセージタイトル */
  deleteModalMessageTitle: string = "";
  /** 削除メッセージ本文 */
  deleteModalMessageText: string = "";

  /** テストメールモーダルの表示状態 */
  testMailModalShow: boolean = false;
  /** テストメール宛先 */
  testMailTargetAddress: string = "";
  /** テストメール宛先家族のソートキー */
  testMailTargetSortKey: string = "";
  /** テストメール宛先家族名(実際には{部屋名}・{利用者名}様 のご家族 {家族名}（{続柄}）様と表示する) */
  testMailFamilyTargetName: string = "";
  /** テストメール宛先家族名 */
  testMailFamilyName: string = "";
  /** テストメール宛先利用者部屋名 */
  testMailResidentRoom: string = "";
  /** テストメール宛先利用者名 */
  testMailResidentName: string = "";
  /** テストメールタイトル */
  testMailSubject: string = "";
  /** テストメール本文 */
  testMailText: string = "";

  /** テストメール確認モーダルの表示状態 */
  testMailConfirmModalShow: boolean = false;
  /** テストメール送信完了モーダル表示可否 */
  showSendMailSuccessModal: boolean = false;

  /**
   * ### 1ページあたりの表示行数の変更イベント
   *
   * - 変更をクッキーに持たせる
   */
  @Watch("perPage")
  changePerPage(perPage: number): void {
    this.setCookie(perPage);
    return;
  }

  /**
   * ### 1ページあたりの表示行数をCookieに設定する
   */
  private setCookie(perPage: number): void {
    // Cookie有効秒数。有効期限は必ず設定しないといけないので、10年分にしておく
    const saveSecond = 10 * 365 * 24 * 60 * 60;
    document.cookie = `resident-list-per-page=${perPage}; max-age=${saveSecond};`;
    return;
  }

  @Watch("sendDeleteMessage")
  changeSendDeleteMessage(sendDeleteMessage: boolean): void {
    this.setCookieForSendDeleteMessage(sendDeleteMessage);
    return;
  }

  /**
   * ### 1ページあたりの表示行数をCookieに設定する
   */
  private setCookieForSendDeleteMessage(sendDeleteMessage: boolean): void {
    // Cookie有効秒数。有効期限は必ず設定しないといけないので、10年分にしておく
    const saveSecond = 10 * 365 * 24 * 60 * 60;
    document.cookie = `resident-list-send-delete-message=${sendDeleteMessage}; max-age=${saveSecond};`;
    return;
  }

  get _userRole(): Role {
    return userStore.loginUser.role;
  }

  get getPlanType(): PlanType {
    return userStore.facility.planType;
  }

  get _plan(): Plan {
    return userStore.facility.plan;
  }

  /**
   * ### 利用者登録上限に達しているかを返す
   *
   * - 施設のプラン毎に利用者登録上限値は異なる
   *
   * @returns 利用者登録上限に達していればtrue
   */
  get _isRegistrationLimit(): boolean {
    let isRegistrationLimit: boolean = false;
    let registrationLimit: number = 0;

    // 現在プランが＋プランの場合は施設固有のプラン情報を返す
    const facility: FacilityGetModel = userStore.facility;
    if ((facility.planType == PlanType.LIGHT && facility.plan == Plan.PLAN_PLUS) || (facility.planType == PlanType.BASIC && facility.plan == Plan.PLAN_PLUS)) {
      const planDetail: PlanDetail = facility.planDetail as PlanDetail;
      registrationLimit = planDetail.residentLimit;
    }
    // 現在プランが＋プラン以外の場合はマスター情報のプラン情報を返す
    else {
      for (const plan of this.plans) {
        if (facility.planType == plan.type && facility.plan == plan.plan) {
          registrationLimit = plan.residentLimit;
        }
      }
    }

    // 上限と比較する
    if (this.rows < registrationLimit) {
      isRegistrationLimit = false;
    } else {
      isRegistrationLimit = true;
    }

    // 利用者数上限が-1の場合は無制限として扱うので強制的にfalseを返す
    if (registrationLimit == -1) {
      isRegistrationLimit = false;
    }

    return isRegistrationLimit;
  }

  /**
   * ### 利用者登録上限人数を返す
   *
   * - 施設のプラン毎に利用者登録上限値は異なる
   *
   * @returns 利用者登録上限人数
   */
  get _registrationLimit(): string {
    let registrationLimit: number = 0;

    // 現在プランが＋プランの場合は施設固有のプラン情報を返す
    const facility: FacilityGetModel = userStore.facility;
    if ((facility.planType == PlanType.LIGHT && facility.plan == Plan.PLAN_PLUS) || (facility.planType == PlanType.BASIC && facility.plan == Plan.PLAN_PLUS)) {
      const planDetail: PlanDetail = facility.planDetail as PlanDetail;
      registrationLimit = planDetail.residentLimit;
    }
    // 現在プランが＋プラン以外の場合はマスター情報のプラン情報を返す
    else {
      for (const plan of this.plans) {
        if (facility.planType == plan.type && facility.plan == plan.plan) {
          registrationLimit = plan.residentLimit;
        }
      }
    }

    // 利用者数上限が-1の場合は無制限を返す
    if (registrationLimit == -1) {
      return "無制限";
    }

    return `${registrationLimit}人`;
  }

  get _enableGetResidentsButton(): boolean {
    if (userStore.facility.cooperationSystems.hitomeQCareSupport || userStore.facility.cooperationSystems.iMedic) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * vue lifecycle mounted
   *
   * 画面表示情報の作成を行う
   */
  public async mounted(): Promise<void> {
    // 画面初期表示時に作成して変更しないものを初期化する
    const fields: Array<ResidentTableField> = this.createFields();
    this.fields = fields;
    // 1ページあたりの表示行数はCookieから取得する。取得できない場合はデフォルト値を使用する
    const perPage: number | null = this.loadCookie();
    this.perPage = perPage ? perPage : Number(Setting.resident.perPage);
    // 削除時のメッセージ送信可否はCookieから取得する。取得出来ない場合はnull（未入力）を使用する
    const sendDeleteMessage: boolean | null = this.loadCookieForSendDeleteMessage();
    this.sendDeleteMessage = sendDeleteMessage != null ? sendDeleteMessage : null;
    // フィルタの復元
    this.restoreFilterSetting();

    await this.initialize();

    return;
  }

  /**
   * ### 利用者の列名を作成する
   */
  public createFields(): Array<ResidentTableField> {
    const fields: Array<ResidentTableField> = [];

    fields.push({ key: "groupName", label: "利用者グループ", sortable: true, sortDirection: "desc", class: "group-name" });
    fields.push({ key: "room", label: "部屋名", sortable: true, sortDirection: "desc", class: "room" });
    fields.push({ key: "name", label: "利用者名", sortable: true, sortDirection: "desc", class: "resident-name" });
    fields.push({ key: "id", label: "利用者ID", sortable: true, sortDirection: "desc", class: "resident-id" });
    fields.push({ key: "family", label: "家族ユーザー", sortable: false, sortDirection: "desc", class: "family" });
    fields.push({ key: "print", label: "ID通知書", sortable: false, sortDirection: "desc", class: "print text-center" });
    fields.push({ key: "operation", label: "登録情報", sortable: false, sortDirection: "desc", class: "operation text-center" });

    return fields;
  }

  /**
   * ### Cookieを見て、値が保持されている場合はCookieの値を返す
   */
  public loadCookie(): number | null {
    if (document.cookie) {
      let cookieMap: any = {};
      let cookies: Array<string> = document.cookie.split("; ");
      cookies.forEach(function (value) {
        //cookie名と値に分ける
        let content = value.split("=");
        cookieMap[content[0]] = content[1];
      });

      // cookieに値が格納されていないとundefinedが格納されているが、実際にはゴミデータが格納されているのでisNaN()でチェックが必要
      const perPage: number = Number(cookieMap["resident-list-per-page"]);

      return isNaN(perPage) ? null : perPage;
    }

    return null;
  }

  private loadCookieForSendDeleteMessage(): boolean | null {
    if (document.cookie) {
      let cookieMap: any = {};
      let cookies: Array<string> = document.cookie.split("; ");
      cookies.forEach(function (value) {
        //cookie名と値に分ける
        let content = value.split("=");
        cookieMap[content[0]] = content[1];
      });

      const sendDeleteMessage: string = cookieMap["resident-list-send-delete-message"];
      if (sendDeleteMessage == "true") {
        return true;
      } else if (sendDeleteMessage == "false") {
        return false;
      } else {
        return null;
      }
    }

    return null;
  }

  /** フィルタ情報がstoreに存在する場合は復元する */
  private restoreFilterSetting(): void {
    if (this.$options.name && itemListFilterStore.filterMap[this.$options.name] != undefined) {
      this.filter = itemListFilterStore.filterMap[this.$options.name];
    }
    return;
  }

  /**
   * ### 画面初期化
   */
  public async initialize(): Promise<void> {
    this.isLoading = true;

    this.items = [];
    this.currentPage = 1;

    await this.createView();

    this.isLoading = false;

    return;
  }

  /**
   * ### 画面情報作成
   */
  public async createView(): Promise<void> {
    // グループIDとグループ名の変換用にグループ情報のMAPを作る
    const groups: Array<ResidentGroupsGetModel> = await this.getResidentGroups();
    const groupNameMap: Map<number, string> = this.createGroupNameMap(groups);
    this.groupNameMap = groupNameMap;

    const filterOptions: Array<{ value: string; text: string }> = await this.createFilterOptions(groups);
    this.filterOptions = filterOptions;

    const plans = await this.getPlans();
    this.plans = plans;

    // 全体の行数を非同期で取得する
    await this.setRows();

    // 利用者テーブルに渡す各プロパティを作成する
    const residents: Array<ResidentGetModel> = await this.getResidents();
    const items: Array<ResidentTableItem> = this.createItems(residents, this.groupNameMap);
    this.items = items;

    // 現在ページがstoreに存在する場合は復元する
    if (this.$options.name && itemListFilterStore.currentPageMap[this.$options.name] != undefined) {
      this.currentPage = itemListFilterStore.currentPageMap[this.$options.name];
    }

    // 登録済み利用者数は利用者グループフィルタリングされていない数を表示させる
    const registerdResidentCount: number = await this.getRegisterdResidentCount();
    this.registerdResidentCount = registerdResidentCount;

    return;
  }

  /**
   * ### 全ての利用者グループを取得する
   */
  public async getResidentGroups(): Promise<Array<ResidentGroupsGetModel>> {
    const response: Array<ResidentGroupsGetModel> = await this.residentGroupsService.gets(userStore);
    return response;
  }

  /**
   * ### グループIDとグループ名のMAPを作成する
   */
  public createGroupNameMap(residentGroups: Array<ResidentGroupsGetModel>): Map<number, string> {
    const groupMap: Map<number, string> = new Map<number, string>();
    for (const group of residentGroups) {
      groupMap.set(group.id, group.name);
    }

    return groupMap;
  }

  /**
   * ### プランを取得する
   */
  public async getPlans(): Promise<Array<PlansGetModel>> {
    const response: Array<PlansGetModel> = await this.plansService.gets(userStore);
    return response;
  }

  /**
   * ### 利用者グループフィルター用選択項目
   *
   * - 検索用に利用者グループマスターのMAPを作る
   * - アカウント情報から許可されている利用者グループIDの配列を取得する
   * - 利用者グループマスターと照合して選択項目の利用者グループを作成する
   */
  public createFilterOptions(residentGroups: Array<ResidentGroupsGetModel>): Array<{ value: string; text: string }> {
    const filterOptions: Array<{ value: string; text: string }> = [];

    filterOptions.push({
      value: "",
      text: "全て"
    });

    const allowedGroupsMap: Map<number, number> = new Map<number, number>();
    for (const allowedGroup of userStore.loginUser.permissions.residentGroups) {
      allowedGroupsMap.set(allowedGroup, allowedGroup);
    }
    for (const group of residentGroups) {
      if (allowedGroupsMap.has(group.id)) {
        filterOptions.push({
          value: `${group.id}`,
          text: group.name
        });
      }
    }

    return filterOptions;
  }

  /**
   * ### ページング用の全件数を設定する
   */
  public async setRows() {
    try {
      const count: number = await this.residentsService.getCount(userStore);
      this.rows = count;
    } catch (error) {
      // 本処理はawaitされない非同期処理なので、共通エラーハンドラーが例外をキャッチしない
      // 例外発生時は自分でエラーハンドラーを呼ぶ
      errorHandle(error, this);
    }

    return;
  }

  /**
   * ### 利用者を作成する
   *
   * - 利用者は取得制限をしないためstartIndex、endIndexを指定しない
   */
  public async getResidents(): Promise<Array<ResidentGetModel>> {
    let response: Array<ResidentGetModel> = [];

    try {
      response = await this.residentsService.gets(userStore);
    } catch (error) {
      const systemerror: SystemError = error as SystemError;
      // 413エラーの場合、全件取得した結果がペイロード制限に引っかかったことになるので、index指定で段階的に取得する
      if (systemerror.statusCode == 413) {
        const count: number = await this.residentsService.getCount(userStore);
        const loopEnd: number = Math.ceil(count / 300);

        for (let i = 0; i < loopEnd; i++) {
          const params: { startIndex: number; endIndex: number } = {
            startIndex: i * 300,
            endIndex: i * 300 + 300
          };
          response = response.concat(await this.residentsService.gets(userStore, params));
        }
      }
    }
    return response;
  }

  /**
   * ### 利用者の行を作成する
   */
  public createItems(residents: Array<ResidentGetModel>, groupNameMap: Map<number, string>): Array<ResidentTableItem> {
    let items: Array<ResidentTableItem> = [];

    for (const resident of residents) {
      const groupName: string | undefined = groupNameMap.get(resident.groupId);
      items.push({
        ...resident,
        groupName: groupName ? groupName : ""
      });
    }

    return items;
  }

  /**
   * ### 登録済み利用者数を取得する
   */
  public async getRegisterdResidentCount(): Promise<number> {
    let response: Array<ResidentGetModel> = [];

    try {
      const params: any = {
        masking: "none"
      };
      response = await this.residentsService.gets(userStore, params);
    } catch (error) {
      const systemerror: SystemError = error as SystemError;
      // 413エラーの場合、全件取得した結果がペイロード制限に引っかかったことになるので、index指定で段階的に取得する
      if (systemerror.statusCode == 413) {
        const pagePerCount: number = 50;
        const count: number = await this.residentsService.getCount(userStore);
        const loopEnd: number = Math.ceil(count / pagePerCount);

        for (let i = 0; i < loopEnd; i++) {
          const params: { startIndex: number; endIndex: number; masking: string } = {
            startIndex: i * pagePerCount,
            endIndex: i * pagePerCount + pagePerCount,
            masking: "none"
          };
          response = response.concat(await this.residentsService.gets(userStore, params));
        }
      }
    }
    return response.length;
  }

  /**
   * ### vue lifecycle activated
   */
  public async activated(): Promise<void> {
    this.$validator.errors.clear();
    this.showValidationAlert = false;

    if (needRefreshesStore.residentList.residentList == true) {
      await this.createView();
      needRefreshesStore.residentList.residentList = false;
    }
    return;
  }

  /**
   * ### 1ページあたりの表示行数変更イベント
   *
   * - 1ページあたりの表示行数を更新
   */
  public async selectPerPage(perPage: number): Promise<void> {
    this.perPage = perPage;
    this.currentPage = 1;
    return;
  }

  /**
   * ### ページネーションのページ番号押下
   */
  public async selectPage(page: number): Promise<void> {
    this.currentPage = page;
    return;
  }

  /**
   * ### 家族の詳細情報を表示する
   */
  public async showFamilies(resident: ResidentTableItem): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "読込み中...";

    this.families = await this.getFamilies(resident);
    this.showFamilyDetailModal = true;

    this.isBusy = false;

    return;
  }

  /**
   * ### 利用者にひもづく家族を取得する
   */
  public async getFamilies(resident: ResidentTableItem): Promise<Array<FamilyGetModel>> {
    const response: Array<FamilyGetModel> = await this.familiesService.getsInResident(userStore, resident.id);
    return response;
  }

  /**
   * ### プリントボタン押下処理
   *
   * ブラウザの印刷プレビューを表示する
   * 未配布の写真の場合、印刷プレビューが閉じられた後に写真配布APIを呼び出して配布する
   */
  public async showServiceRegisterGuide(resident: ResidentTableItem): Promise<void> {
    // プレビュー表示は子コンポーネントに機能を委譲しているので、子コンポーネントを表示するのみ
    const pdf: RegistrationGuidePdfModal | Vue | Element | Vue[] | Element[] = this.$refs.pdf;
    if (pdf instanceof RegistrationGuidePdfModal) {
      await pdf.show(resident);
    }
    return;
  }

  /**
   * ### 利用者登録画面へ遷移
   */
  public gotoResidentRegister(): void {
    this.$router.push(PcUrl.ResidentRegister);
    return;
  }

  /**
   * ### 利用者一括登録画面へ遷移
   */
  public gotoMultipleResidentRegister(): void {
    this.$router.push(PcUrl.ResidentMultipleRegister);
    return;
  }

  /**
   * ### 連携システムから取得画面へ遷移
   */
  public gotoGetResidentsForCooperationSystem(): void {
    this.$router.push(PcUrl.ResidentRegisterForCooperationSystem);
    return;
  }

  /**
   * ### 利用者グループ一覧画面へ遷移
   */
  public gotoResidentGroupList(): void {
    this.$router.push(PcUrl.ResidentGroupList);
    return;
  }

  public gotoResidentDetail(residentId: number): void {
    this.$router.push({ name: PcUrl.ResidentDetail, params: { id: `${residentId}` } });
    return;
  }

  /**
   * ### 利用者編集画面へ遷移
   */
  public gotoResidentEdit(residentId: number): void {
    this.$router.push({ name: PcUrl.ResidentEdit, params: { id: `${residentId}`, type: "0" } });
    return;
  }

  /**
   * ### 削除確認モーダルを表示する
   *
   * - 削除メッセージは動的に作成する
   */
  public showConfirmDeleteModal(resident: ResidentTableItem): void {
    this.deleteTargetId = resident.id;

    // 家族が登録されている場合は削除メッセージの初期値を入力する
    if (0 < resident.familyCount) {
      this.showSendDeleteMessage = true;
      this.deleteModalMessageTitle = "ユーザー登録が削除されました";
      const deleteMessages = [];
      deleteMessages.push(`ご利用の施設から${resident.name}様の登録情報が削除されましたので、ユーザー登録を削除させていただきました。`);
      deleteMessages.push("今までHitomeQコネクトをご愛顧いただきありがとうございました。");
      this.deleteModalMessageText = deleteMessages.join("\n");
    } else {
      this.showSendDeleteMessage = false;
      this.deleteModalMessageTitle = "";
      this.deleteModalMessageText = "";
    }

    const room: string = resident.room ? resident.room : "";
    const name: string = resident.name ? resident.name : "";
    this.deleteMessage = `${room}${name}様の利用者情報を削除しますか？`;

    this.showDeleteModal = true;

    return;
  }

  /**
   * ### 利用者とひもづく家族を削除する
   */
  public async doDelete(): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "削除中...";
    this.showDeleteModal = false; // モーダルでバリデーションがあるので呼び出し元で表示／非表示を管理する

    const requestBody: ResidentDeleteModel = {
      deleteMessageTitle: this.sendDeleteMessage ? this.deleteModalMessageTitle : "",
      deleteMessageText: this.sendDeleteMessage ? this.deleteModalMessageText : ""
    };
    await this.residentsService.delete(userStore, this.deleteTargetId, requestBody);

    // 削除成功ダイアログを表示する
    this.showDeleteSuccessModal = true;
    this.isBusy = false;

    // itemsから削除した利用者を削除するだけで再取得リクエストはしない
    this.items = this.items.concat().filter((item: ResidentTableItem) => {
      if (item.id == this.deleteTargetId) {
        return false;
      } else {
        return true;
      }
    });
    this.rows--;
    this.registerdResidentCount--;
    // 家族一覧を再読み込みさせるようstoreを更新
    let familyList: FamilyListState = needRefreshesStore.familyList;
    familyList.familyList = true;
    needRefreshesStore.setFamilyList(familyList);
    // メッセージ送信の宛先が変更になるので再読み込みさせるようstoreを更新
    let sendMessageState: SendMessagesState = needRefreshesStore.sendMessage;
    sendMessageState.sendMessages = true;
    needRefreshesStore.setSendMessage(sendMessageState);

    return;
  }

  /**
   * ### 家族メールユーザー編集画面へ遷移
   */
  public gotoFamilyEdit(family: FamilyGetModel): void {
    this.$router.push({ name: PcUrl.ResidentFamilyEdit, params: { residentid: `${family.id}`, id: `${family.familyId}` } });
    return;
  }

  /**
   * ### 家族ユーザー削除確認モーダルを表示する
   *
   * - 削除メッセージを動的に作成する
   */
  public showConfirmFamilyDeleteModal(family: FamilyGetModel): void {
    this.deleteTargetResidentId = family.id;
    this.deleteTargetFamilyId = family.familyId;

    this.showSendDeleteMessage = true;
    this.deleteModalMessageTitle = "ユーザー登録が削除されました";
    const deleteMessages = [];
    deleteMessages.push(`ご利用の施設から${family.familyName}様の登録情報が削除されましたので、ユーザー登録を削除させていただきました。`);
    deleteMessages.push("今までHitomeQコネクトをご愛顧いただきありがとうございました。");
    this.deleteModalMessageText = deleteMessages.join("\n");

    const room: string = family.room ? family.room : "";
    const residentName: string = family.name ? family.name : "";
    const familyName: string = family.familyName ? family.familyName : "";
    const familyRelation: string = family.familyRelation ? `（${family.familyRelation}）` : "";
    this.deleteMessage = `${room} ${residentName}様のご家族${familyName}${familyRelation}様を削除しますか？`;

    this.showFamilyDeleteModal = true;

    return;
  }

  /**
   * ### 家族ユーザーを削除する
   */
  public async deleteFamily(): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "削除中...";
    this.showFamilyDeleteModal = false;

    const requestBody: FamilyDeleteModel = {
      deleteMessageTitle: this.sendDeleteMessage ? this.deleteModalMessageTitle : "",
      deleteMessageText: this.sendDeleteMessage ? this.deleteModalMessageText : ""
    };
    await this.familiesService.delete(userStore, this.deleteTargetResidentId, this.deleteTargetFamilyId, requestBody);

    // 削除成功ダイアログを表示する
    this.showFamilyDetailModal = false;
    this.showFamilyDeleteSuccessModal = true;
    this.isBusy = false;

    // 家族を削除した利用者の情報を更新するだけで再取得リクエストはしない
    for (const item of this.items) {
      if (item.id == this.deleteTargetResidentId) {
        item.familyCount--;
      }
    }
    // 家族一覧を再読み込みさせるようstoreを更新
    let familyList: FamilyListState = needRefreshesStore.familyList;
    familyList.familyList = true;
    needRefreshesStore.setFamilyList(familyList);
    // メッセージ送信の宛先が変更になるので再読み込みさせるようstoreを更新
    let sendMessageState: SendMessagesState = needRefreshesStore.sendMessage;
    sendMessageState.sendMessages = true;
    needRefreshesStore.setSendMessage(sendMessageState);

    return;
  }

  /**
   * ### 家族メールユーザー削除確認モーダルを表示する
   */
  public showConfirmMailFamilyDeleteModal(family: FamilyGetModel): void {
    // 削除メッセージを動的に作成する
    const room: string = family.room ? family.room : "";
    const residentName: string = family.name ? family.name : "";
    const familyName: string = family.familyName ? family.familyName : "";
    const familyRelation: string = family.familyRelation ? `（${family.familyRelation}）` : "";
    this.deleteMessage = `${room} ${residentName} 様のご家族 ${familyName}${familyRelation}様を削除しますか？`;
    this.showDeleteMailFamilyModal = true;

    this.deleteTargetResidentId = family.id;
    this.deleteTargetFamilyId = family.familyId;

    return;
  }

  /**
   * ### 家族メールユーザーを削除する
   */
  public async deleteMailFamily(): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "削除中...";

    await this.mailFamiliesService.delete(userStore, this.deleteTargetResidentId, this.deleteTargetFamilyId);

    // 削除成功ダイアログを表示する
    this.showFamilyDetailModal = false;
    this.showFamilyDeleteSuccessModal = true;
    this.isBusy = false;

    // 家族を削除した利用者の情報を更新するだけで再取得リクエストはしない
    for (const item of this.items) {
      if (item.id == this.deleteTargetResidentId) {
        item.familyCount--;
      }
    }
    // 家族一覧を再読み込みさせるようstoreを更新
    let familyList: FamilyListState = needRefreshesStore.familyList;
    familyList.familyList = true;
    needRefreshesStore.setFamilyList(familyList);
    // メッセージ送信の宛先が変更になるので再読み込みさせるようstoreを更新
    let sendMessageState: SendMessagesState = needRefreshesStore.sendMessage;
    sendMessageState.sendMessages = true;
    needRefreshesStore.setSendMessage(sendMessageState);

    return;
  }

  /**
   * ### テストメール送信モーダルを表示する
   *
   * - テストメール送信モーダルに必要な情報を作成する
   * - モーダルを表示する
   */
  public showTestMailModal(family: FamilyGetModel): void {
    this.testMailTargetAddress = family.familyMailaddress ? family.familyMailaddress : "";
    this.testMailTargetSortKey = family.residentsSortKey;
    this.testMailFamilyTargetName = `${family.room}・${family.name}様 のご家族 ${family.familyName}（${family.familyRelation}）様`;
    this.testMailFamilyName = `${family.familyName}`;
    this.testMailResidentRoom = `${family.room}`;
    this.testMailResidentName = `${family.name}`;
    this.testMailSubject = "HitomeQコネクト登録確認メール";
    this.testMailText =
      "HitomeQコネクトのメール配信サービスへのお申し込みありがとうございます。\n" +
      "お申し込みのメールアドレスを登録致しました。\n" +
      "後ほど受信確認のご連絡をさせていただきます。\n\n" +
      "もしお心当たりの無い場合は、本メールを削除してください。";

    this.testMailModalShow = true;

    return;
  }

  /**
   * ### テストメール送信確認モーダルを表示する
   *
   * - テストメールの内容をバリデーションする
   * - バリデーションで問題が無ければテストメール確認モーダルを表示する
   */
  public async confirmSendMail(): Promise<void> {
    await this.$validator.reset();
    const validationResult: boolean = await this.$validator.validateAll();
    if (validationResult) {
      this.showValidationAlert = false;
      this.testMailConfirmModalShow = true;
    } else {
      this.showValidationAlert = true;
    }
    return;
  }

  /**
   * ### テストメールを送信する
   *
   * - メールを送信するのでテストメールモーダル、テストメール確認モーダルを非表示にする
   * - メール送信用のパラメータを作成する
   * - メールを送信する
   */
  public async sendMail(): Promise<void> {
    this.testMailModalShow = false;
    this.testMailConfirmModalShow = false;

    this.isBusy = true;
    this.loadingMessage = "送信中...";

    const sendMailMessage: SendMailMessagesPostModel = this.createSendMailMessageModel();
    await this.sendMailMessagesService.post(userStore, sendMailMessage);

    // 送信成功ダイアログを表示する
    this.showFamilyDetailModal = false;
    this.showSendMailSuccessModal = true;
    this.isBusy = false;

    return;
  }

  /**
   * ### メール送信用パラメータを作成する
   */
  public createSendMailMessageModel(): SendMailMessagesPostModel {
    const sendMailMessage: SendMailMessagesPostModel = {
      sortKeys: [this.testMailTargetSortKey],
      targetName: this.testMailFamilyName,
      subject: this.$stringUtil.convertYen(this.testMailSubject),
      text: this.$stringUtil.convertYen(this.testMailText),
      writerId: userStore.loginUser.userId,
      writtenBy: userStore.loginUser.name,
      // メッセージ送信画面でしか使用しないので以下は空相当の情報を格納する
      type: "",
      addOptionText: false,
      addReadButton: false,
      addReplyButton: false,
      fileUrls: [],
      fileNames: [],
      addReceivedMessageUrl: false,
      needDbRegister: false
    };

    return sendMailMessage;
  }

  /**
   * ### 利用者一覧をCSVダウンロードする
   */
  public onCsvDownload(): void {
    const csv: string = this.createCsv(this.items);
    const fileName: string = this.createCsvFileName();
    this.downloadCsv(csv, fileName);
    return;
  }

  /**
   * ### 利用者一覧CSVを作成する
   *
   * - 1行目の先頭はexcel等での文字化け対策でBOMを付与する
   * - 1行目は項目名を作る
   * - 2行目以降は行情報にあたる情報を作成して出力する
   */
  public createCsv(items: Array<ResidentTableItem>): string {
    const csv: string[] = [];
    const rowNames: string[] = ["利用者グループ", "部屋名", "利用者名", "性別", "生年月日", "電話番号", "保険者番号", "介護保険被保険者番号", "家族ユーザー数"];
    csv.push(`\ufeff` + `${rowNames.join(",")}`);

    for (const item of items) {
      const line: string[] = [];

      line.push(item.groupName);
      line.push(item.room);
      line.push(item.name);
      line.push(item.gender);
      line.push(item.birthday ? this.$dateUtil.convertNumberToString(item.birthday, "yyyy/mm/dd") : "");
      line.push(item.tel ? `="${item.tel}"` : "");
      line.push(item.insuredNumber ? `="${item.insuredNumber}"` : "");
      line.push(item.careInsuranceInsuredNumber ? `="${item.careInsuranceInsuredNumber}"` : "");
      line.push(`${item.familyCount}`);

      csv.push(`${line.join(",")}`);
    }
    return csv.join("\n");
  }

  /**
   * ### CSVファイル名を作成する
   */
  public createCsvFileName(): string {
    const date: string = this.$dateUtil.convertDateToString(new Date(), "yyyymmdd");
    const fileName: string = `HitomeQコネクト-利用者一覧-${date}.csv`;
    return fileName;
  }

  /**
   * ### CSVファイルをダウンロードさせる
   *
   * - CSVの内容からblobファイルを作成する
   * - blobファイルの種別はtext/csv
   * - a要素を作ってそれを疑似的にクリックさせることでダウンロードさせる
   */
  public downloadCsv(csv: string, fileName: string): void {
    const blob: Blob = new Blob([csv], { type: "text/csv" });
    let link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
    return;
  }

  /**
   * ### 画面情報を再取得する
   */
  public async refresh(): Promise<void> {
    await this.initialize();
    return;
  }

  /**
   * ### vue lifecycle deactivated
   *
   * - コンポーネントをkeep-aliveでキャッシュしている
   * - validatorインスタンスもキャッシュしてしまっているので、リセットする
   */
  async deactivated() {
    await this.$validator.reset();
    this.$validator.errors.clear();
    this.showValidationAlert = false;

    // 画面を離れる前に現在のフィルタリング条件をVuexに保存
    if (this.$options.name) {
      itemListFilterStore.setFilter({ url: this.$options.name, filter: this.filter });
      itemListFilterStore.setCurrentPage({ url: this.$options.name, currentPage: this.currentPage });
    }
    return;
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";
@import "../../../styles/pc/_mixin.scss";

#resident-list {
  max-width: 1280px;
  margin-left: auto;
  margin-right: auto;

  .box-header {
    .title {
      font-size: 22px;
      font-weight: bold;
    }
  }
  .box-body {
    .refresh-icon {
      @include svg-icon("../../../assets/refresh.svg", $font-base-color, 20px, 20px);
      opacity: 0.5;
      text-shadow: 0 1px 0 #fff;
      cursor: pointer;
    }
    .refresh-icon:hover {
      opacity: 0.75;
    }
  }
  .download-btn {
    height: 38px !important;
  }
}
</style>
